module.exports = __webpack_public_path__ + "static/img/son10.1bee4fd3.jpg";